<template>
    <rkm-data-table
        :fields="fields.datatables.exame"
        :repository="repositories.exame"
        ref="DataTable"
        sort-by="exame"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'parametrizacao-exame-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-parametrizacao-exame"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-parametrizacao-exame"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    exame: [
                        {
                            name: 'parametrizacaoExame.nome',
                            key: 'exame',
                            label: 'Nome',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'parametrizacaoExameTipo.nome',
                            key: 'tipo',
                            label: 'Tipo',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'cadastroGrupo.nome',
                            key: 'grupo',
                            label: 'Grupo',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'procedimento.nome',
                            key: 'procedimentoNome',
                            label: 'Procedimento',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'procedimento.codigo',
                            key: 'procedimentoCodigo',
                            label: 'Código',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'actions',
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame')
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.exame.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o exame?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>